import DeviceItem from './DeviceItem'
export default  DeviceItem;